import { Link } from "react-router-dom";

const STATS = [
  { value: "128", label: "收录作品" },
  { value: "436", label: "演员档案" },
  { value: "1,024", label: "篇剧情长文" },
];

export default function EditorialBlock() {
  return (
    <section className="shell mt-12 md:mt-16" aria-label="关于华丽的外出">
      <div className="grid grid-cols-1 items-stretch gap-0 overflow-hidden rounded-lg border border-background-200 bg-secondary-50 lg:grid-cols-12">
        <div className="relative h-56 w-full lg:col-span-5 lg:h-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20editorial%20photograph%20of%20a%20cozy%20independent%20cinema%20lobby%20with%20framed%20abstract%20posters%2C%20warm%20amber%20lamps%20and%20deep%20navy%20walls%2C%20empty%20velvet%20seats%20in%20soft%20focus%2C%20film%20grain%2C%20no%20text&width=900&height=760&seq=hlwc-editorial-01&orientation=landscape"
            alt="华丽的外出 编辑室氛围图"
            title="华丽的外出 影视内容编辑部"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 to-transparent lg:bg-gradient-to-r" />
          <span className="absolute bottom-4 left-4 rounded-md bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-foreground-800">
            编辑部手记 · 2025 秋
          </span>
        </div>

        <div className="lg:col-span-7 lg:p-10">
          <div className="p-5 sm:p-7 lg:p-0">
            <div className="flex items-center gap-2">
              <span className="h-3 w-1 rounded-full bg-accent-500" />
              <span className="font-label text-xs font-semibold uppercase tracking-[0.18em] text-accent-700">
                About Us
              </span>
            </div>
            <h2 className="mt-2.5 text-xl font-bold md:text-[26px]">我们为什么写剧情</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              华丽的外出始于几个人的观影笔记。我们相信，一部作品真正留下来的，
              往往不是最响的那场戏，而是某个被忽略的细节：一句没说完的话、一盏没关的灯。
            </p>
            <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">
              所以我们把剧情拆开写，把演员的功课摊开讲，把剧集的时间线整理清楚。
              不剧透关键转折，但也不敷衍地带过。
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3 border-t border-background-300/70 pt-5">
              {STATS.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl font-extrabold text-primary-700">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-2.5">
              <Link
                to="/category/all"
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                浏览全部作品
                <i className="ri-arrow-right-line text-sm" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                投稿与建议
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}